import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
import { AuthGuard } from './@auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'pages',
    loadChildren: () => import('./pages/pages.module')
      .then(m => m.PagesModule),
    canActivate:[AuthGuard]
  },
  {
    path: 'students',
    loadChildren: () => import('./pages/students/students.module')
      .then(m => m.StudentsModule),
 
  },
    {
    path: 'schools',
    loadChildren: () => import('./pages/schools/schools.module')
      .then(m => m.SchoolsModule),
 
  },
     {
    path: 'tutor',
    loadChildren: () => import('./pages/all-users/all-users.module')
      .then(m => m.AllUsersModule),
 
  },
       {
    path: 'schools',
    loadChildren: () => import('./pages/schools/schools.module')
      .then(m => m.SchoolsModule),
 
  },
   {
    path: 'guardian-students',
    loadChildren: () => import('./pages/guardian-students/guardian-students.module')
      .then(m => m.GuardianStudentsModule),
 
  },
  {
    path: 'auth',
    loadChildren: () => import('./@auth/auth.module')
      .then(m => m.NbAuthModule)
  },
  // {
  //   path: 'auth',
  //   component: NbAuthComponent,
  //   children: [
  //     {
  //       path: '',
  //       component: NbLoginComponent,
  //     },
  //     {
  //       path: 'login',
  //       component: NbLoginComponent,
  //     },
  //     {
  //       path: 'register',
  //       component: NbRegisterComponent,
  //     },
  //     {
  //       path: 'logout',
  //       component: NbLogoutComponent,
  //     },
  //     {
  //       path: 'request-password',
  //       component: NbRequestPasswordComponent,
  //     },
  //     {
  //       path: 'reset-password',
  //       component: NbResetPasswordComponent,
  //     },
  //   ],
  // },
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth' },
];

const config: ExtraOptions = {
  useHash: false,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
